import { SECTIONS } from "@/lib/sections";

export const EmptyState = ({ phase, hasMedia, failed }) => (
  <div data-testid="analysis-empty-state">
    <div className="flex items-center gap-4 pb-6 border-b border-[var(--rf-ink)]">
      <h2 className="text-lg font-bold tracking-tight">Reverse editing</h2>
      <span className="rf-mono text-[10px] tracking-[0.25em] uppercase text-[var(--rf-grey)]" data-testid="analysis-empty-status">
        {phase === "uploading" ? <span className="rf-red">● Caricamento del file…</span>
          : failed ? <span className="rf-red">Analisi non riuscita</span>
          : hasMedia ? "Pronto — premi Analizza" : "In attesa di un file"}
      </span>
    </div>
    {SECTIONS.map((s) => (
      <div key={s.n} className="grid grid-cols-12 gap-4 py-6 border-b rf-line">
        <span className="col-span-3 text-5xl font-black tracking-tighter leading-none text-[#e5e5e5]">{String(s.n).padStart(2, "0")}</span>
        <div className="col-span-9">
          <p className="font-bold text-[#b5b5b5]">{s.it}</p>
          <p className="rf-mono text-[10px] tracking-[0.15em] uppercase text-[#c8c8c8] mt-1">{s.en}</p>
        </div>
      </div>
    ))}
  </div>
);
